<script>
import { HorizontalBar } from 'vue-chartjs';
export default {
	extends: HorizontalBar,
	props: {
		num: Number,
		max: Number,
		min: Number,
	},
	mounted() {
		this.renderChart(
			{
				datasets: [
					{
						backgroundColor: '#0004FF',
						data: [this.num],
					},
				],
			},
			{
				responsive: true,
				maintainAspectRatio: false,
				tooltips: {
					enabled: false,
				},
				scales: {
					xAxes: [
						{
							display: false,
							ticks: {
								max: this.max,
								min: this.min,
							},
						},
					],
					yAxes: [
						{
							display: false,
						},
					],
				},
				legend: {
					display: false,
				},
				plugins: {
					datalabels: {
						display: false,
					},
				},
				/*
				animation: {
					duration: 1,
					onComplete: function() {
						let chartInstance = this.chart;
						let ctx = chartInstance.ctx;
						ctx.textAlign = 'center';
						ctx.fillStyle = 'rgba(0, 0, 0, 1)';
						ctx.textBaseline = 'bottom';

						// Loop through each data in the datasets
						this.data.datasets.forEach(function(dataset, i) {
							var meta = chartInstance.controller.getDatasetMeta(i);
							meta.data.forEach(function(bar, index) {
								var data = dataset.data[index];
								ctx.fillText(data, bar._model.x + 10, bar._model.y + 8);
							});
						});
					},
				}, */
			},
		);
	},
};
</script>

<style></style>
